export { default } from './GraphTab';
